export interface TeamMeta { code: string; bg: string; fg: string }

const TEAMS: Record<string, TeamMeta> = {
  "Arsenal": { code: "ARS", bg: "#EF0107", fg: "#FFFFFF" },
  "Aston Villa": { code: "AVL", bg: "#670E36", fg: "#95BFE5" },
  "AFC Bournemouth": { code: "BOU", bg: "#DA291C", fg: "#000000" },
  "Brentford": { code: "BRE", bg: "#E30613", fg: "#FFFFFF" },
  "Brighton & Hove Albion": { code: "BHA", bg: "#0057B8", fg: "#FFFFFF" },
  "Chelsea": { code: "CHE", bg: "#034694", fg: "#FFFFFF" },
  "Coventry City": { code: "COV", bg: "#59CBE8", fg: "#000000" },
  "Crystal Palace": { code: "CRY", bg: "#1B458F", fg: "#C4122E" },
  "Everton": { code: "EVE", bg: "#003399", fg: "#FFFFFF" },
  "Fulham": { code: "FUL", bg: "#FFFFFF", fg: "#000000" },
  "Hull City": { code: "HUL", bg: "#F5A12D", fg: "#000000" },
  "Ipswich Town": { code: "IPS", bg: "#0044A9", fg: "#FFFFFF" },
  "Leeds United": { code: "LEE", bg: "#FFFFFF", fg: "#1D428A" },
  "Liverpool": { code: "LIV", bg: "#C8102E", fg: "#F6EB61" },
  "Manchester City": { code: "MCI", bg: "#6CABDD", fg: "#1C2C5B" },
  "Manchester United": { code: "MUN", bg: "#DA291C", fg: "#FBE122" },
  "Newcastle United": { code: "NEW", bg: "#241F20", fg: "#FFFFFF" },
  "Nottingham Forest": { code: "NFO", bg: "#DD0000", fg: "#FFFFFF" },
  "Sunderland": { code: "SUN", bg: "#EB172B", fg: "#FFFFFF" },
  "Tottenham Hotspur": { code: "TOT", bg: "#132257", fg: "#FFFFFF" },
};

const FALLBACK = ["#0E7A3E", "#1D4ED8", "#B91C1C", "#7C3AED", "#EA580C", "#0F766E"];

export function teamMeta(name: string): TeamMeta {
  if (TEAMS[name]) return TEAMS[name];
  const code = name.replace(/[^A-Za-z ]/g, "").split(" ").filter(Boolean).map((w) => w[0]).join("").slice(0, 3).toUpperCase() || name.slice(0, 3).toUpperCase();
  const bg = FALLBACK[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % FALLBACK.length];
  return { code: code.length < 3 ? name.slice(0, 3).toUpperCase() : code, bg, fg: "#FFFFFF" };
}

export const LMS_HERO = "/img/99e7a1ffc80c.webp";
export const LMS_SHARE = "https://static.prod-images.emergentagent.com/jobs/77e1310a-796c-47e5-b9ac-713ea6fba8f2/images/99e7a1ffc80ccc0a8617332f69032b3404d86d4c7e943a88d38ec50e488ea5d5.jpeg";
